"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var baseUrl = 'snippets/v1/render';

var _default = function _default(apiClient) {
  return {
    fetchRenderedContent: function fetchRenderedContent(_ref) {
      var id = _ref.id,
          contactEmail = _ref.contactEmail,
          contactVid = _ref.contactVid,
          supplementalObjects = _ref.supplementalObjects;
      return apiClient.post(baseUrl, {
        data: {
          snippetId: id,
          toEmail: contactEmail,
          contactId: contactVid,
          supplementalObjects: supplementalObjects
        }
      });
    },
    fetchUnrenderedContent: function fetchUnrenderedContent(_ref2) {
      var id = _ref2.id;
      return apiClient.get("snippets/v1/snippets/" + id);
    },
    searchSnippets: function searchSnippets(_ref3) {
      var count = _ref3.count,
          offset = _ref3.offset,
          query = _ref3.query;
      return apiClient.post('salescontentsearch/v2/search', {
        data: {
          contentTypesToHydrate: ['SNIPPET'],
          filters: [{
            field: 'content_type',
            values: ['SNIPPET']
          }],
          limit: count,
          offset: offset,
          query: query
        }
      }).then(function (response) {
        return (0, _immutable.fromJS)(response);
      });
    }
  };
};

exports.default = _default;
module.exports = exports.default;